const _ = require("lodash");
const ImageCache = require("./ImageCache");

// Assumes the color images are in a subfolder /color from the base image (fixSVGs.js can produce the color versions of SVGs)
const getPremadeColorImage = function(baseUrl, rawColor, rawColors) {
	const colors = _.map(rawColors, c => c.toUpperCase());
	const color = (rawColor && rawColor.toUpperCase()) || "";

	const regex = /(.*\/)(.*)(\..*)/;
	const match = regex.exec(baseUrl);
	if (!match) return;

	const [, baseFolderPath, baseImageName, fileExt] = match;

	let colorSuffix = "";
	let folderSuffix = "";
	if (color && _.includes(colors, color)) {
		folderSuffix = "color/";
		colorSuffix = "-" + color.substring(color.lastIndexOf("#") + 1);
	}

	return ImageCache.src(
		baseFolderPath + folderSuffix + baseImageName + colorSuffix + fileExt
	);
};

const drawImageInRect = function(
	context,
	imageSrc,
	rect,
	hPadding,
	vPadding,
	rotation = 0,
	isReflected,
	scale = 1
) {
	context.save();
	const image = ImageCache.src(imageSrc, true);
	if (isReflected) {
		context.translate(2 * rect.x + rect.w, 0);
		context.scale(-1, 1);
		rotation *= -1;
	}
	context.rotateAboutDeg(rotation, rect.x + rect.w / 2, rect.y + rect.h / 2);
	const x = rect.x + hPadding;
	const y = rect.y + vPadding;
	const w = rect.w - 2 * hPadding;
	const h = rect.h - 2 * vPadding;
	const extraPadding = (scale - 1) / 2;
	context.drawImage(
		image,
		x - w * extraPadding,
		y - h * extraPadding,
		w * scale,
		h * scale
	);
	context.restore();
};

module.exports = {
	getPremadeColorImage,
	drawImageInRect,
};
